import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { INSIGHTS } from "@/data/insights";

export const Route = createFileRoute("/_app/insights/")({
  head: () => {
    const canonical = "/insights";
    return buildHead({
      title: "Market Insights & Steel Intelligence | LohaLink",
      description:
        "Scrap price analysis, grading field guides, GST and policy explainers, and green-steel research for India's ferrous and steel trade — from the LohaLink market desk.",
      canonical,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "LohaLink Market Insights & Steel Intelligence",
          url: "https://lohalink.in/insights",
          description:
            "Market trends, scrap grading guides, GST and policy explainers, and green-steel analysis for India's ferrous trade.",
          mainEntity: {
            "@type": "ItemList",
            itemListElement: INSIGHTS.map((a, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: a.title,
              url: `https://lohalink.in/insights/${a.slug}`,
            })),
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://lohalink.in/" },
            { "@type": "ListItem", position: 2, name: "Market Insights", item: "https://lohalink.in/insights" },
          ],
        },
      ],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/Insights")),
});
